import { createSelector } from 'reselect';
import { nullIfEmptyLocalizedString } from '@synergy/utils';

import { AppState } from '../../../../../store/models/app-state';
import { HeaderBannerDetailRequest } from '../models/header-banner-detail-request';
import { HeaderBannerFormValues } from '../models/header-banner-form-values';

const headerBannerDetailState = (state: AppState) => state.contentManagement.headerBanner.headerBannerDetail;
const supportedLocales = (state: AppState) => state.supportedLocales;

export const headerBannerDetailSelector = createSelector(headerBannerDetailState, state => state.headerBanner);
export const headerBannerDetailRequestingSelector = createSelector(headerBannerDetailState, state => state.requesting);
export const headerBannerDetailFormValues = createSelector(
    [headerBannerDetailState, supportedLocales],
    (state, locales) => {
        const banner = state.headerBanner;
        const getLocalizedString = (values: { [key: string]: string }) => {
            const localizedString: { [key: string]: string } = {};
            locales.forEach(locale => (localizedString[locale] = values[locale] ?? ''));
            return localizedString;
        };

        return {
            ...banner,
            image: banner?.image ? { name: '', contentBase64: '', pathname: banner.image['1920x400'] } : null,
            mobileImage: banner?.mobileImage
                ? { name: '', contentBase64: '', pathname: banner?.mobileImage['375x375'] }
                : null,
            validFrom: banner?.validFrom ?? null,
            validTo: banner?.validTo ?? null,
            buttonText: getLocalizedString(banner?.buttonText ?? {}),
            buttonUrl: getLocalizedString(banner?.buttonUrl ?? {}),
            headline: getLocalizedString(banner?.headline ?? {}),
            subHeadline: getLocalizedString(banner?.subHeadline ?? {}),
        };
    }
);

export const headerBannerDetailRequestSelector = (values: HeaderBannerFormValues) =>
    createSelector(headerBannerDetailState, state => {
        const request: HeaderBannerDetailRequest = {
            id: state.headerBanner?.id,
            image: values.image?.contentBase64 ? values.image : null,
            mobileImage: values.mobileImage?.contentBase64 ? values.mobileImage : null,
            validFrom: values.validFrom ?? new Date(),
            validTo: values.validTo ?? new Date(),
            buttonText: nullIfEmptyLocalizedString(values?.buttonText),
            buttonUrl: nullIfEmptyLocalizedString(values?.buttonUrl),
            headline: nullIfEmptyLocalizedString(values?.headline),
            subHeadline: nullIfEmptyLocalizedString(values?.subHeadline),
        };

        return request;
    });
